// The Helibrain brain mark: the traced brain line art on a transparent
// background (no white disc), as two small PNGs of the same artwork:
//   brain-mark-blue.png  — brand blue, for light surfaces
//   brain-mark-light.png — lighter blue, for dark surfaces
// "auto" follows the visitor's colour scheme (page background); "onDark" is
// for surfaces that are dark in both themes (the footer). Plain <img>/<picture>
// on purpose: browsers that force-darken pages leave images alone, and the
// fine line art stays crisp served as-is (144 px wide, ~11 KB).

const SRC = {
  blue: "/images/brain-mark-blue.png",
  light: "/images/brain-mark-light.png",
};
const RATIO = 119 / 144; // height / width of the artwork

export function BrandMark({
  width,
  surface = "auto",
  className,
  priority = false,
}: {
  width: number;
  surface?: "auto" | "onDark";
  className?: string;
  priority?: boolean;
}) {
  const height = Math.round(width * RATIO);
  const img = (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={surface === "onDark" ? SRC.light : SRC.blue}
      alt=""
      width={width}
      height={height}
      className={className}
      decoding="async"
      fetchPriority={priority ? "high" : undefined}
    />
  );
  if (surface === "onDark") return img;
  return (
    <picture>
      <source srcSet={SRC.light} media="(prefers-color-scheme: dark)" />
      {img}
    </picture>
  );
}
